export default {
  PENDING_BROWSER_CHECK: 'PENDING_BROWSER_CHECK',
  PENDING_CHALLENGE: 'PENDING_CHALLENGE',
  PENDING_AUTHORISATION: 'PENDING_AUTHORISATION',
};
